import { useEffect, useRef } from 'react';

const VoiceRemoteAudio = ({ stream }) => {
  const audioRef = useRef(null);

  useEffect(() => {
    if (!audioRef.current) return;
    audioRef.current.srcObject = stream || null;
  }, [stream]);

  return <audio ref={audioRef} autoPlay playsInline />;
};

export default VoiceRemoteAudio;
